import { TextArea } from '@bechtel/gds';
import styled, { css } from 'styled-components';
export const LocationDescriptionStyled = styled(TextArea)`
  ${({ theme }) =>
    css`
      font-size: ${theme.fontSizes[400]};
      font-family: ${theme.fontFamilies['graphik']};
      color: ${theme.colors.grey[1000]};
    `}
`;
